import { render, staticRenderFns } from "./DealArrangementsGrid.vue?vue&type=template&id=67f5a0a4&"
import script from "./DealArrangementsGrid.vue?vue&type=script&lang=ts&"
export * from "./DealArrangementsGrid.vue?vue&type=script&lang=ts&"
import style0 from "./DealArrangementsGrid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67f5a0a4')) {
      api.createRecord('67f5a0a4', component.options)
    } else {
      api.reload('67f5a0a4', component.options)
    }
    module.hot.accept("./DealArrangementsGrid.vue?vue&type=template&id=67f5a0a4&", function () {
      api.rerender('67f5a0a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "module/Deals/view/vue/components/DealArrangementsGrid.vue"
export default component.exports